export default __webpack_public_path__ + "static/media/loginVaisand.188c34bf.jpg";